import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const PresaleIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M4.16675 15.0003C4.16675 14.5401 4.53984 14.167 5.00008 14.167H6.66675C7.12699 14.167 7.50008 14.5401 7.50008 15.0003C7.50008 15.4606 7.12699 15.8337 6.66675 15.8337H5.00008C4.53984 15.8337 4.16675 15.4606 4.16675 15.0003Z"
          fill="#0D7A26"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5589 1.66699C13.6873 1.66696 14.6178 1.66694 15.3543 1.76596C16.1275 1.86991 16.8103 2.09655 17.3571 2.64331C17.9039 3.19006 18.1305 3.87292 18.2345 4.64611C18.3335 5.38257 18.3334 6.31308 18.3334 7.4415V12.5591C18.3334 13.6875 18.3335 14.6181 18.2345 15.3545C18.1305 16.1277 17.9039 16.8106 17.3571 17.3574C16.8103 17.9041 16.1275 18.1307 15.3543 18.2347C14.6178 18.3337 13.6873 18.3337 12.5589 18.3337H7.4413C6.31287 18.3337 5.38233 18.3337 4.64586 18.2347C3.87267 18.1307 3.18982 17.9041 2.64306 17.3574C2.0963 16.8106 1.86966 16.1277 1.76571 15.3545C1.6667 14.6181 1.66672 13.6876 1.66675 12.5592V7.44152C1.66672 6.3131 1.6667 5.38257 1.76571 4.64611C1.86966 3.87292 2.0963 3.19006 2.64306 2.64331C3.18982 2.09655 3.87267 1.86991 4.64586 1.76596C5.38232 1.66694 6.31282 1.66696 7.44124 1.66699H12.5589ZM11.2501 3.33366H8.75008V5.83366H11.2501V3.33366ZM7.08342 3.33387V6.66699C7.08342 6.88801 7.17121 7.09997 7.32749 7.25625C7.48377 7.41253 7.69573 7.50033 7.91675 7.50033H12.0834C12.5437 7.50033 12.9167 7.12723 12.9167 6.66699V3.33387C13.8956 3.33525 14.5934 3.34532 15.1322 3.41776C15.7206 3.49687 15.9931 3.63634 16.1786 3.82182C16.3641 4.00729 16.5035 4.27981 16.5827 4.86819C16.665 5.48054 16.6668 6.29826 16.6668 7.50033V12.5003C16.6668 13.7024 16.665 14.5201 16.5827 15.1325C16.5035 15.7208 16.3641 15.9934 16.1786 16.1788C15.9931 16.3643 15.7206 16.5038 15.1322 16.5829C14.5199 16.6652 13.7022 16.667 12.5001 16.667H7.50008C6.29801 16.667 5.48029 16.6652 4.86794 16.5829C4.27957 16.5038 4.00705 16.3643 3.82157 16.1788C3.6361 15.9934 3.49662 15.7208 3.41752 15.1325C3.33519 14.5201 3.33342 13.7024 3.33342 12.5003V7.50033C3.33342 6.29826 3.33519 5.48054 3.41752 4.86819C3.49662 4.27981 3.6361 4.00729 3.82157 3.82182C4.00705 3.63634 4.27957 3.49687 4.86794 3.41776C5.40677 3.34532 6.10462 3.33525 7.08342 3.33387Z"
          fill="#0D7A26"
        />
      </svg>
    );
  }
);

export default PresaleIcon;
